<div class="toggler">
    @if(!binary()) {
    <div class="toggler__left-value cursor-pointer" [class.selected]="selectedValue().value === leftValue().value"
        [pTooltip]="leftValue()?.tooltip ?? ''" (click)="selectedValue.set(leftValue());leftValue().click()">
        @if(isIcon(leftValue().value)) {
        <i [ngClass]="leftValue().value"></i>
        }@else {
        {{leftValue().label}}
        }

    </div>
    <div class="toggler__right-value cursor-pointer" [class.selected]="selectedValue().value === rightValue().value"
        (click)="selectedValue.set(rightValue());rightValue().click()" [pTooltip]="rightValue()?.tooltip ?? ''">
        @if(isIcon(rightValue().value)) {
        <i [ngClass]="rightValue().value"></i>
        }@else {
        {{rightValue().label}}
        }
    </div>

    }@else {
    <div class="toggler__left-value cursor-pointer" [class.selected]="ngModel() === true" (click)="ngModel.set(true)">
        Vrai</div>
    <div class="toggler__right-value cursor-pointer" [class.selected]="ngModel() === false"
        (click)="ngModel.set(false)">Faux</div>
    }
</div>